import gql from 'graphql-tag';

export const GET_METABASE_DASHBOARD_IFRAME_URL = gql`
  query GetMetabaseSignedIframeURL($input: MetaBaseDashboardInput!) {
    metaBaseDashboard(input: $input) {
      url
      success
    }
  }
`;
